import { NavigationItemModel } from 'common/src/models';
import { CompanyProfile } from '../../../administration/models/company-profile.model';

export function getWarehouseNavItems(companyProfile: CompanyProfile): NavigationItemModel[] {
  return [
    {
      icon: 'pin',
      disabled: false,
      title: 'WAREHOUSE.ADDRESS_AND_CONTACTS',
      routerLink: './address-and-contacts',
      showCondition: companyProfile.subscriptionManagement.subscriptionPermissions.ADDRESSES_AND_CONTACTS
    },
    {
      icon: 'stock-status',
      disabled: false,
      title: 'WAREHOUSE.BIN_LOCATIONS',
      routerLink: './bin-locations',
      showCondition: companyProfile.subscriptionManagement.subscriptionPermissions.BIN_LOCATIONS
    },
    {
      icon: 'options-2',
      disabled: false,
      title: 'DOC_BLOCK.PREFERENCES',
      routerLink: './preferences',
      showCondition: companyProfile.subscriptionManagement.subscriptionPermissions.BIN_LOCATIONS
    },
  ].filter(i => !i.hasOwnProperty('showCondition') || i.showCondition);
}
